import { httpClient } from '@core/http/client';

export abstract class BaseRepository {
  protected async getAll<T>(
    endpoint: string,
    params?: Record<string, string | number | boolean | undefined>
  ): Promise<T> {
    const response = await httpClient.get(endpoint, { params });
    return response.data.data ?? response.data;
  }

  protected async getById<T>(endpoint: string, id: string): Promise<T> {
    const response = await httpClient.get(`${endpoint}/${id}`);
    return response.data.data ?? response.data;
  }

  protected async create<T, D>(endpoint: string, data: D): Promise<T> {
    const response = await httpClient.post(endpoint, data);
    return response.data.data ?? response.data;
  }

  protected async update<T, D>(endpoint: string, id: string, data: D): Promise<T> {
    const response = await httpClient.put(`${endpoint}/${id}`, data);
    return response.data.data ?? response.data;
  }

  /**
   * PUT request with body containing identifier (no URL param).
   * Used when API expects the identifier inside the request body,
   * e.g. PUT /field-ticket with { ticket_id_external: "..." } in body.
   */
  protected async updateWithBody<T, D>(endpoint: string, data: D): Promise<T> {
    const response = await httpClient.put(endpoint, data);
    return response.data.data ?? response.data;
  }

  protected async delete(endpoint: string, id: string): Promise<void> {
    await httpClient.delete(`${endpoint}/${id}`);
  }

  /**
   * DELETE request with JSON body (no URL param).
   * Used when API expects parameters in the request body,
   * e.g. DELETE /defect-line with { ticket_id_external, defect_line_id }.
   */
  protected async deleteWithBody<D>(endpoint: string, data: D): Promise<void> {
    await httpClient.delete(endpoint, { data });
  }
}
